import styled from 'styled-components'

export const Container = styled.div<any>`
  color: ${props => props.theme.palette.general.light};
  background: ${props => props.theme.palette.state[props.state]};
  border-radius: 2px;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: ${props => props.theme.maxWidth};
    min-height: 50px;
    margin: 0 auto;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 2px;
  }
`
